import { IconSad } from 'components/icons/sad';

export const DEFAULT_ICON = IconSad;
